import React from 'react'
import { Badge } from 'react-bootstrap'

type VoucherStateBadgeProps = {
  state: string
}

const VoucherStateBadge: React.FC<VoucherStateBadgeProps> = ({ state }) => {
  let variant: string

  switch (state) {
    case 'PAID':
      variant = 'success'
      break
    case 'REJECTED':
      variant = 'danger'
      break
    case 'APPROVED':
      variant = 'primary'
      break
    case 'PENDING':
      variant = 'info'
      break
    case 'SUBMITTED':
      variant = 'secondary'
      break
    case 'DRAFT':
      variant = 'warning'
      break
    default:
      variant = 'dark'
  }

  return <Badge bg={variant}>{state}</Badge>
}

export default VoucherStateBadge
